import React, { useEffect, useState } from 'react';
import { Virtuoso } from 'react-virtuoso';
import { Wrapper } from './styles';
import { useI18nContext } from '../../utils/I18n';
import {useRoadSearchStore} from "../../store/roadSearch/roadSearchStore";
import BusDetails from "./BusDetails";

type Props = {
  results?: RoadSearchResult,
  selectedBuses: AvailableBus[]
  onBookingRedirect: () => void
  onBusSelect: (arg: AvailableBus[]) => void
  cheapestFares: {
    cheapestDeparture: number | null,
    cheapestReturn: number | null
  },
  onLoadMore: () => void,
  loadingMore?: boolean
}

const PAGE_SIZE = 50;

function AvailableBuses({ results, onBookingRedirect, onBusSelect, selectedBuses, cheapestFares, onLoadMore, loadingMore
}: Props) {
  const departureBuses = results?.FirstLeg?.ResultList || [];
  const returnBuses = results?.SecondLeg?.ResultList || [];
  const cheapestDeparture = cheapestFares?.cheapestDeparture;
  const cheapestReturn = cheapestFares?.cheapestReturn;
  const { formData: { TripType }, selectedResult, selectedBusSeat, updateStoreData } = useRoadSearchStore();
  const isReturning = selectedBuses.length > 0;
  const isOneWay = TripType === 'one_way';
  const tripsSessionId = results?.TripsSessionId;

  const [visibleCount, setVisibleCount] = useState(PAGE_SIZE);

  useEffect(() => {
    setVisibleCount(PAGE_SIZE);
  }, [results, isReturning]);

  const handleEndReached = (activeListLength: number) => {
    setVisibleCount((prev) => Math.min(prev + PAGE_SIZE, activeListLength));
  };


  const handleSelectBus = (resultItem: BusResultItem, bus: AvailableBus, seats: AvailableSeat[]) => {
    if(isOneWay) {
      onBookingRedirect();
      updateStoreData({
        tripsSessionId,
        selectedResult: [resultItem],
        selectedBusSeat: [seats],
        selectedBus: [bus]
      });
      return;
    }

    if (!isReturning) {
      onBusSelect([bus]);
      updateStoreData({
        tripsSessionId,
        selectedResult: [resultItem],
        selectedBusSeat: [seats],
        selectedBus: [bus]
      })
    } else {
      let resultItems = [...selectedResult];
        resultItems[1] = resultItem;
      let selections = [...selectedBuses];
      selections[1] = bus;
      let busSeats = [...selectedBusSeat];
      busSeats[1] = seats;

      const storeData = {
        selectedResult: resultItems,
        selectedBus: selections,
        selectedBusSeat: busSeats,
      };
      onBusSelect(selections);
      updateStoreData(storeData);
      onBookingRedirect();
    }
  };


  const renderBusItem = (cheapestFare: number | null, onlyDepartureSelected: boolean, isReturningLeg: boolean) =>
    (index: number, bus: BusResultItem) => (
      <BusDetails
        cheapestFare={cheapestFare}
        result={bus}
        handleSelectBus={handleSelectBus}
        onlyDepartureSelected={onlyDepartureSelected}
        isReturning={isReturningLeg}
      />
    );
  
  const ListFooter = () =>
    loadingMore ? (
      <div style={{ padding: '50px 20px', textAlign: 'center' }}>
        Loading more flights...
      </div>
    ) : null;
  
    return (
    <Wrapper>
      {!isReturning && (
        <Virtuoso
          useWindowScroll
          data={departureBuses}
          itemContent={renderBusItem(cheapestDeparture, !isOneWay, false)}
          // endReached={onLoadMore}
          // components={{ Footer: ListFooter }}
        />
      )}

      {isReturning && (
        <Virtuoso
          useWindowScroll
          data={returnBuses}
          itemContent={renderBusItem(cheapestReturn, false, true)}
          // endReached={onLoadMore}
          // components={{ Footer: ListFooter }}
        />
      )}
    </Wrapper>
  );
}

AvailableBuses.defaultProps = {
  loading: false,
  error: undefined,
  results: {
    TotalCount: 0,
    ResultList: [],
  },
};
export default AvailableBuses;
